import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import SellerConcerns from './components/SellerConcerns';
import WhySellWithCarol from './components/WhySellWithCarol';
import HomeValuationCTA from './components/HomeValuationCTA';
import SellingProcess from './components/SellingProcess';
import SituationsHelp from './components/SituationsHelp';
import AboutPreview from './components/AboutPreview';
import TestimonialsSection from './components/TestimonialsSection';
import LatestSellerAdvice from './components/LatestSellerAdvice';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <HeroSection />
      <SellerConcerns />
      <WhySellWithCarol />
      <HomeValuationCTA />
      <SellingProcess />
      <SituationsHelp />
      <AboutPreview />
      <TestimonialsSection />
      <LatestSellerAdvice />
      <FinalCTA />
      <Footer />
    </div>
  );
}